import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-eb9cd48a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "container" };
var _hoisted_2 = { class: "header shadow-custom rounded-lg pt-14 lg:pt-28 pb-7 px-10 text-white" };
var _hoisted_3 = {
    key: 1,
    class: "background rounded-lg"
};
var _hoisted_4 = { class: "flex flex-col lg:flex-row items-center text-center lg:text-left" };
var _hoisted_5 = { class: "mt-5 lg:mt-0 lg:ml-5" };
var _hoisted_6 = { class: "text-lg text-primary" };
var _hoisted_7 = { class: "text-3xl font-medium" };
var _hoisted_8 = ["innerHTML"];
import { parseTextWithUrl } from '@common/utils/String/String';
import { CoreStore } from '@student/modules/store';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'HeaderPanel',
    setup: function (__props) {
        var school = computed(function () { return CoreStore.school; });
        // const backgroundImage = computed(() => school.value.cover ? school.value.cover : '/img/pagesStudent/courses/coursesHeader/bg.jpg')
        return function (_ctx, _cache) {
            var _a;
            var _component_avatar = _resolveComponent("avatar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    (school.value.cover)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: _normalizeStyle({ 'backgroundImage': 'url(' + school.value.cover + ')' }),
                            class: "background rounded-lg"
                        }, null, 4))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_avatar, {
                            src: school.value.avatar,
                            class: "!w-20 !h-20 border-2 border-white"
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(school.value.tagline), 1),
                            _createElementVNode("p", _hoisted_7, _toDisplayString((_a = school.value.name) !== null && _a !== void 0 ? _a : ''), 1),
                            _createElementVNode("p", {
                                class: "mt-2 school-description",
                                innerHTML: _unref(parseTextWithUrl)({ text: school.value.description })
                            }, null, 8, _hoisted_8)
                        ])
                    ])
                ])
            ]));
        };
    }
});
